import React from 'react';
import { useDispatch } from 'react-redux';
import { setParticipant } from '../../store/participant/participant';

interface Props {
  id: string;
  name: string;
  participant: any;
}

const ToggleSwitch: React.FC<Props> = ({ id, name, participant }) => {
    const dispatch = useDispatch();

    const handleToggle = () => {
        dispatch(
            setParticipant({
                ...participant,
                [name]: !participant[name],
            })
        );
    };

    return (
        <label className={`switch ${participant[name] ? 'active' : ''}`} htmlFor={id}>
            <input
                type="checkbox"
                id={id}
                name={name}
                checked={participant[name]}
                onChange={handleToggle}
                aria-checked={participant[name]}
            />
            <span className={`slider ${participant[name] ? 'active' : ''}`}>
                <span className={`pill ${participant[name] ? 'checked' : ''}`}></span>
                <span className={`labelText left ${participant[name] ? 'active' : ''}`}>Zustimmen</span>
                <span className={`labelText right ${participant[name] ? '' : 'active'}`}>Ablehnen</span>
            </span>
        </label>
    );
};

export default ToggleSwitch;
